import { render } from "./index.vue?vue&type=template&id=b3ceb06a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=b3ceb06a&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ceb06a"]])

export default __exports__